import { ComponentProps } from 'react'

import { cn } from '@/shared/lib'

export const Skeleton = ({ className, ...props }: ComponentProps<'div'>) => {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-gray-100', className)}
      {...props}
    />
  )
}
